import React, { useEffect, useState } from "react";
import { Checkbox, Form, Dropdown, Space } from "antd";
import type { CheckboxProps } from "antd";
import { ChevronIcon } from "../assets";

const CheckboxGroup = Checkbox.Group;

const MultipleCheckbox: React.FC<any> = ({
  form,
  name,
  label,
  permissions,
}: any) => {
  const [checkedList, setCheckedList] = useState<string[]>([]);

  const checkAll = permissions.length === checkedList.length;
  const indeterminate =
    checkedList.length > 0 && checkedList.length < permissions.length;

  function updateFormValues(list: string[]) {
    const currentPermissions = form.getFieldValue("permissions") || {};

    if (list.includes("edit") || list.includes("approve")) {
      form.setFieldValue("permissions", {
        ...currentPermissions,
        [name]: permissions,
      });
    } else {
      form.setFieldValue("permissions", {
        ...currentPermissions,
        [name]: list,
      });
    }
  }
  const onChange = (list: string[]) => {
    setCheckedList(list);
    updateFormValues(list);
  };

  const onCheckAllChange: CheckboxProps["onChange"] = (e) => {
    const newCheckedList = e.target.checked ? permissions : [];
    setCheckedList(newCheckedList);
    updateFormValues(newCheckedList);
  };

  useEffect(() => {
    const permission = form.getFieldValue(["permissions", name]);
    if (permission) {
      setCheckedList(permission);
    }
  }, [form, name]);

  return (
    <Dropdown
      dropdownRender={() => (
        <Form.Item name={["permissions", name]}>
          <CheckboxGroup
            options={permissions}
            value={checkedList}
            onChange={onChange}
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#232323",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 12px 32px rgba(0,0,0,0.28)",
              padding: 12,
              borderRadius: 14,
            }}
          />
        </Form.Item>
      )}
    >
      <Space size={0}>
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
        >
          {label}
        </Checkbox>
        <ChevronIcon />
      </Space>
    </Dropdown>
  );
};

export default MultipleCheckbox;
